import { Button, Grid, IconButton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import GKClientDataGrid from "components/GKClientDataGrid";
import dayjs from "dayjs";
import { useState } from "react";
import { MdEdit } from "react-icons/md";
import axiosInstance from "utils/axiosInstance";
import GroupModal from "./GroupModal";

const Group = () => {
  const [groupModal, setGroupModal] = useState(undefined);
  const [groupData, setGroupData] = useState({});

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["GET_ALL_GROUP"],
    queryFn: () => axiosInstance.get("/advisor_group/"),
  });

  const columns = [
    {
      field: "title",
      headerName: "Group Name",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
      valueFormatter: (params) => dayjs(params?.value).format("DD MMM YYYY"),
      valueGetter: (row) => row?.row?.createdAt || "N/A",
    },
    {
      field: "action",
      headerName: "Actions",
      disableColumnMenu: true,
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 80,
      type: "action",
      renderCell: (item) => (
        <Grid container gap={1} justifyContent="flex-end">
          <IconButton
            color="primary"
            onClick={(event) => {
              event.stopPropagation();
              setGroupData(item.row);
              setGroupModal(true);
            }}
          >
            <MdEdit size={20} />
          </IconButton>
        </Grid>
      ),
    },
  ];

  const GroupDetailTable = (params) => {
    const { row } = params;

    const columns = [
      {
        field: "name",
        headerName: "Name",
        flex: 1,
        disableColumnMenu: true,
        minWidth: 150,
      },
      {
        field: "phone",
        headerName: "Phone",
        flex: 1,
        disableColumnMenu: true,
        minWidth: 150,
      },
      {
        field: "companyName",
        headerName: "Company Name",
        flex: 1,
        disableColumnMenu: true,
        minWidth: 150,
      },
    ];

    return (
      <Grid container px={2} py={1}>
        <GKClientDataGrid
          density="compact"
          columns={columns}
          loading={isFetching}
          rows={row.users || []}
        />
      </Grid>
    );
  };

  return (
    <>
      <GKClientDataGrid
        loading={isFetching}
        columns={columns}
        rows={data?.data?.data || []}
        getDetailPanelContent={GroupDetailTable}
        headerComponent={
          <Grid container item xs={12} gap={1} justifyContent="flex-end">
            <Button
              sx={{
                fontSize: "0.7rem",
                fontFamily: '"Arial", sans-serif',
                textTransform: "none",
              }}
              onClick={() => {
                setGroupData({});
                setGroupModal(!groupModal);
              }}
              variant="contained"
            >
              Create Group
            </Button>
          </Grid>
        }
      />
      {groupModal && (
        <GroupModal
          open={groupModal}
          setOpen={setGroupModal}
          refetch={refetch}
          groupData={groupData}
        />
      )}
    </>
  );
};

export default Group;
